import {ChangeDetectionStrategy, Component, Inject, Input, OnInit} from '@angular/core';


require('./task-capacity-bars.scss');
@Component({
  standalone: false,
  selector: 'app-task-capacity-bars',
  templateUrl: './task-capacity-bars.html',
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class TaskCapacityBarsComponent implements OnInit {

  @Input() currentLoad: any;
  @Input() isColumn: boolean;

  public weightUnit: any;
  public volumeUnit: any;

  constructor(@Inject("splitService") private splitService) {
  }

  ngOnInit() {
    this.weightUnit = this.splitService.getWeightUnit();
    this.volumeUnit = this.splitService.getVolumeUnit();
  }

}
